import { render } from "./HeroSectionPage.vue?vue&type=template&id=26ae3c04"
const script = {}

import "./HeroSectionPage.vue?vue&type=style&index=0&id=26ae3c04&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__